(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
window.addEventListener('load', function(){
  /*
  window.setTimeout(function(){
  const infiniteSlider = new Swiper(".announcement-bar__carousel", {
    loop: true,
    loopedSlides: 2,
    slidesPerView: "auto",
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
  })
}, 5000);
*/
});

  } catch(e) { console.error(e); }
})();
})();
